export { default as BottomNav } from "./BottomNav";
export * from "./BottomNav";
